/**
 * Sauce custom v2 – autoplay carousel + quick-buy modal enhancements.
 */
(function () {
  'use strict';

  var PAUSE_SRC =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMzczQTQwIj48cmVjdCB4PSI2IiB5PSI0IiB3aWR0aD0iNCIgaGVpZ2h0PSIxNiIgcng9IjEiLz48cmVjdCB4PSIxNCIgeT0iNCIgd2lkdGg9IjQiIGhlaWdodD0iMTYiIHJ4PSIxIi8+PC9zdmc+';
  var PLAY_SRC =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMzczQTQwIj48cG9seWdvbiBwb2ludHM9IjggNSAxOSAxMiA4IDE5Ii8+PC9zdmc+';

  function normalizeHandle(value) {
    var handle = (value || '').trim();
    if (!handle) return '';
    return handle.charAt(0) === '@' ? handle : '@' + handle;
  }

  function buildUgcSlideHtml(imageSrc, videoSrc, igBadgeHtml) {
    var badge = igBadgeHtml || '';
    if (videoSrc) {
      return (
        '<div class="sauce-v2__modal-slide sauce-v2__modal-slide--ugc">' +
        '<video class="sauce-v2__modal-slide-media" src="' +
        videoSrc +
        '"' +
        (imageSrc ? ' poster="' + imageSrc + '"' : '') +
        ' muted loop playsinline autoplay preload="auto" disablepictureinpicture></video>' +
        badge +
        '</div>'
      );
    }
    if (imageSrc) {
      return (
        '<div class="sauce-v2__modal-slide sauce-v2__modal-slide--ugc">' +
        '<img class="sauce-v2__modal-slide-media" src="' +
        imageSrc +
        '" alt="">' +
        badge +
        '</div>'
      );
    }
    return '';
  }

  function setupModalVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function buildIgBadgeHtml(handle) {
    var igText = normalizeHandle(handle);
    if (!igText) return '';
    return '<span class="sauce-v2__ig sauce-v2__ig--modal">' + igText.replace(/</g, '&lt;') + '</span>';
  }

  function applyModalMedia(modal) {
    var mode = modal.getAttribute('data-sauce-media-mode') || 'auto';
    var ugcImage = modal.getAttribute('data-sauce-ugc-image') || '';
    var ugcVideo = modal.getAttribute('data-sauce-ugc-video') || '';
    var productImage = modal.getAttribute('data-sauce-product-image') || '';
    var igHandle = modal.getAttribute('data-sauce-instagram') || '';
    var galleryWrapper = modal.querySelector('.quick-buy-modal__gallery-wrapper');
    if (!galleryWrapper) return;

    // Limpiar badge antiguo del área de info (versiones previas)
    modal.querySelectorAll('.sauce-v2__modal-instagram').forEach(function (el) {
      el.remove();
    });

    // auto: vídeo del bloque > imagen del bloque > galería del producto
    var useUgc = false;
    var includeProduct = false;

    if (mode === 'product') {
      useUgc = false;
    } else if (mode === 'ugc') {
      useUgc = !!(ugcVideo || ugcImage);
    } else if (mode === 'both') {
      useUgc = !!(ugcVideo || ugcImage);
      includeProduct = true;
    } else {
      // auto (default)
      useUgc = !!(ugcVideo || ugcImage);
    }

    if (!useUgc) {
      modal.setAttribute('data-sauce-media-ready', 'true');
      return;
    }

    var mobileInfo = galleryWrapper.querySelector('.quick-buy-modal__mobile-info');
    // Badge IG solo en slides UGC (foto/vídeo del bloque), mismo diseño que el carrusel
    var slidesHtml = buildUgcSlideHtml(ugcImage, ugcVideo, buildIgBadgeHtml(igHandle));

    if (includeProduct && productImage) {
      slidesHtml +=
        '<div class="sauce-v2__modal-slide">' +
        '<img class="sauce-v2__modal-slide-media" src="' +
        productImage +
        '" alt="">' +
        '</div>';
    }

    if (!slidesHtml) {
      modal.setAttribute('data-sauce-media-ready', 'true');
      return;
    }

    var existingGallery = galleryWrapper.querySelector('product-gallery, .product-gallery');
    if (existingGallery) existingGallery.remove();

    var customGallery = galleryWrapper.querySelector('.sauce-v2__modal-gallery');
    if (customGallery) customGallery.remove();

    var gallery = document.createElement('div');
    gallery.className = 'sauce-v2__modal-gallery';
    gallery.innerHTML = slidesHtml;
    if (mobileInfo) {
      galleryWrapper.insertBefore(gallery, mobileInfo);
    } else {
      galleryWrapper.prepend(gallery);
    }

    gallery.querySelectorAll('video').forEach(setupModalVideo);
    modal.setAttribute('data-sauce-media-ready', 'true');
  }

  function enhanceQuickBuyModal(modal) {
    if (!modal || !modal.classList.contains('sauce-v2__quick-buy-modal')) return;
    if (!modal.querySelector('.quick-buy-modal__gallery-wrapper')) return;
    applyModalMedia(modal);
  }

  function scheduleEnhance(modal) {
    enhanceQuickBuyModal(modal);
    requestAnimationFrame(function () {
      enhanceQuickBuyModal(modal);
    });
  }

  function watchModalContent(modal) {
    if (!modal || modal.__sauceContentWatch) return;
    modal.__sauceContentWatch = true;

    var observer = new MutationObserver(function () {
      if (!modal.querySelector('.quick-buy-modal__gallery-wrapper')) return;
      // Inyectar UGC en cuanto el quick-buy mete el HTML (antes del flash)
      modal.removeAttribute('data-sauce-media-ready');
      enhanceQuickBuyModal(modal);
    });

    observer.observe(modal, { childList: true, subtree: false });
  }

  function extractProductHandle(href) {
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return null;
      var handle = match[1];
      var variant = url.searchParams.get('variant');
      return variant ? handle + '?variant=' + variant : handle;
    } catch (error) {
      return null;
    }
  }

  async function swapSauceModalProduct(modal, handleAttr) {
    if (!modal || !handleAttr || modal.getAttribute('data-ru-swapping') === 'true') return;

    modal.setAttribute('data-ru-swapping', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'products/' + handleAttr);
      if (!response.ok) throw new Error('Product fetch failed');

      var html = await response.text();
      var tempDoc = new DOMParser().parseFromString(html, 'text/html');
      var template = tempDoc.getElementById('quick-buy-content');
      if (!template || !template.content) throw new Error('Quick buy content missing');

      var content = template.content.cloneNode(true);
      Array.from(content.querySelectorAll('noscript')).forEach(function (noScript) {
        noScript.remove();
      });

      modal.setAttribute('handle', handleAttr);
      modal.replaceChildren(content);

      var featuredImg = modal.querySelector(
        '.quick-buy-modal__gallery-wrapper .product-gallery img, .quick-buy-modal__gallery-wrapper img'
      );
      if (featuredImg && (featuredImg.currentSrc || featuredImg.src)) {
        modal.setAttribute('data-sauce-product-image', featuredImg.currentSrc || featuredImg.src);
      }

      scheduleEnhance(modal);

      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
    } catch (error) {
      console.error(error);
      var fallbackRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = fallbackRoot + 'products/' + String(handleAttr).split('?')[0];
    } finally {
      modal.removeAttribute('data-ru-swapping');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  function bindQuickBuyEnhancements() {
    if (window.__sauceV2QuickBuyBound) return;
    window.__sauceV2QuickBuyBound = true;

    document.querySelectorAll('quick-buy-modal.sauce-v2__quick-buy-modal').forEach(watchModalContent);

    // capture: dialog:after-show no burbujea
    document.addEventListener(
      'dialog:after-show',
      function (event) {
        var modal = event.target;
        if (!modal || !modal.classList || !modal.classList.contains('sauce-v2__quick-buy-modal')) return;
        watchModalContent(modal);
        scheduleEnhance(modal);
      },
      true
    );

    document.addEventListener(
      'dialog:after-hide',
      function (event) {
        var modal = event.target;
        if (!modal || !modal.classList || !modal.classList.contains('sauce-v2__quick-buy-modal')) return;
        modal.removeAttribute('data-sauce-media-ready');
        modal.querySelectorAll('video').forEach(function (video) {
          video.pause();
        });
      },
      true
    );

    // Troca de cor (thumbnail-swatch): recarrega o modal sem ir à PDP
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a[href]');
        if (!link) return;

        var modal = link.closest('quick-buy-modal.sauce-v2__quick-buy-modal');
        if (!modal) return;
        if (!link.closest('.variant-picker__option-values')) return;

        if (link.classList.contains('is-selected')) {
          event.preventDefault();
          return;
        }

        var handleAttr = extractProductHandle(link.getAttribute('href'));
        if (!handleAttr) return;

        event.preventDefault();
        event.stopPropagation();
        swapSauceModalProduct(modal, handleAttr);
      },
      true
    );
  }

  function initCarousel(root) {
    if (!root || root.dataset.sauceV2Ready === 'true') return;
    root.dataset.sauceV2Ready = 'true';

    var track = root.querySelector('[data-sauce-v2-track]');
    var toggle = root.querySelector('[data-sauce-v2-autoplay-toggle]');
    if (!track || track.classList.contains('sauce-v2__track--stacked')) return;

    var enableAutoplay = root.dataset.autoplay === 'true';
    var speedSeconds = parseFloat(root.dataset.autoplaySpeed) || 6;
    var icon = toggle ? toggle.querySelector('img') : null;
    var playing = enableAutoplay;
    var intervalId = null;
    var snapTimer = null;
    var loopWidth = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userInteracting = false;
    var resumeTimer = null;

    function cardStep() {
      var card = track.querySelector('.sauce-v2__card:not([data-sauce-clone])');
      if (!card) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function measureOriginalWidth() {
      var originals = Array.prototype.slice.call(track.children).filter(function (el) {
        return !el.hasAttribute('data-sauce-clone');
      });
      if (originals.length === 0) return 0;
      var first = originals[0];
      var last = originals[originals.length - 1];
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
      return last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
    }

    function ensureLoopContent() {
      var originals = Array.prototype.slice.call(track.children).filter(function (el) {
        return !el.hasAttribute('data-sauce-clone');
      });
      if (originals.length === 0) return;

      track.querySelectorAll('[data-sauce-clone]').forEach(function (el) {
        el.remove();
      });

      function appendCloneSet() {
        originals.forEach(function (el) {
          var clone = el.cloneNode(true);
          clone.setAttribute('data-sauce-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          clone.tabIndex = -1;
          track.appendChild(clone);
        });
      }

      appendCloneSet();

      var safety = 0;
      while (track.scrollWidth < track.clientWidth * 2.1 && safety < 8) {
        appendCloneSet();
        safety += 1;
      }

      loopWidth = measureOriginalWidth();
    }

    function setToggleUi() {
      if (!toggle || !icon) return;
      if (playing) {
        icon.src = PAUSE_SRC;
        icon.alt = '';
        toggle.setAttribute('aria-label', 'Pausar carrusel');
        toggle.setAttribute('aria-pressed', 'false');
      } else {
        icon.src = PLAY_SRC;
        icon.alt = '';
        toggle.setAttribute('aria-label', 'Reproducir carrusel');
        toggle.setAttribute('aria-pressed', 'true');
      }
    }

    function snapLoopIfNeeded() {
      if (loopWidth <= 0) return;
      if (track.scrollLeft >= loopWidth - 1) {
        track.scrollLeft = track.scrollLeft - loopWidth;
      }
    }

    function advance() {
      if (!playing || userInteracting) return;

      var step = cardStep();
      if (step <= 0) return;

      if (snapTimer) clearTimeout(snapTimer);

      track.scrollBy({ left: step, behavior: reduceMotion ? 'auto' : 'smooth' });

      snapTimer = setTimeout(function () {
        snapLoopIfNeeded();
        snapTimer = null;
      }, reduceMotion ? 0 : 520);
    }

    function clearTimers() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      if (snapTimer) {
        clearTimeout(snapTimer);
        snapTimer = null;
      }
    }

    function stop() {
      playing = false;
      clearTimers();
      setToggleUi();
    }

    function start() {
      if (reduceMotion || !enableAutoplay) {
        playing = false;
        setToggleUi();
        return;
      }
      ensureLoopContent();
      playing = true;
      setToggleUi();
      clearTimers();
      intervalId = setInterval(advance, speedSeconds * 1000);
    }

    function pauseTemporarily() {
      userInteracting = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        userInteracting = false;
        snapLoopIfNeeded();
      }, 1800);
    }

    if (toggle) {
      if (!enableAutoplay || reduceMotion) {
        toggle.hidden = true;
      } else {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          if (playing) {
            stop();
          } else {
            start();
          }
        });
      }
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pauseTemporarily, { passive: true });
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (playing) {
          var wasPlaying = playing;
          clearTimers();
          ensureLoopContent();
          if (wasPlaying) {
            intervalId = setInterval(advance, speedSeconds * 1000);
          }
        }
      }, 200);
    });

    if (enableAutoplay && !reduceMotion) {
      start();
    } else {
      playing = false;
      setToggleUi();
    }
  }

  function boot(scope) {
    bindQuickBuyEnhancements();
    (scope || document).querySelectorAll('[data-sauce-v2]').forEach(function (root) {
      initCarousel(root);
    });
  }

  window.SauceCustomV2 = {};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
